// Font Family
export const FontFamilyRegular = 'CeraPRO-Regular, Helvetica, sans-serif'
export const FontFamilyBold = 'CeraPRO-Bold, Helvetica, sans-serif'

// Font Sizes
export const FontSizeXLarge = '2rem'
export const FontSizeLarge = '1.5rem'
export const FontSizeMedium = '1.2rem'
export const FontSizeSmall = '1rem'
